import { useEffect, useRef, useState } from "react";
import { tickerItems } from "@/mocks/leakHome";

export default function TopBar() {
  const [active, setActive] = useState(0);
  const timer = useRef<number | null>(null);

  useEffect(() => {
    timer.current = window.setInterval(() => {
      setActive((p) => (p + 1) % tickerItems.length);
    }, 3600);
    return () => {
      if (timer.current) window.clearInterval(timer.current);
    };
  }, []);

  return (
    <div className="w-full bg-red-600 text-white">
      <div className="mx-auto flex max-w-[1280px] items-center gap-3 px-4 py-1.5 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-white/15 px-2 py-0.5 text-[11px] font-bold tracking-wide">
          <i className="ri-flashlight-fill text-[12px]"></i>
          最新上墙
        </span>
        <div className="relative h-5 flex-1 overflow-hidden">
          {tickerItems.map((t, i) => (
            <p
              key={i}
              className={`absolute inset-0 flex items-center text-xs text-red-50 transition-all duration-500 ${
                i === active ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
              }`}
            >
              {t}
            </p>
          ))}
        </div>
        <a
          href="#feed"
          className="hidden shrink-0 items-center gap-1 text-xs font-semibold hover:text-white md:flex"
        >
          刷全部 <i className="ri-arrow-right-line text-[12px]"></i>
        </a>
      </div>
    </div>
  );
}